// -----------------------------------------------------------------------------
// <copyright file="shared.module.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CustomToolTipComponent } from './components/custom-tool-tip/custom-tool-tip.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { SelectComponent } from './components/select/select.component';
import { ClickOutsideDirective } from './directives/click-outside';
import { CustomToolTipDirective } from './directives/custom-tooltip.directive';
import { TooltipDirective } from './directives/tt.directive';
import { PopoverModule } from './popover/popover.module';
import { ButtonComponent } from './components/button/button';
import { VsDatePipe } from './pipes/date.pipe';
import { NoValuePipe } from './pipes/no-value.pipe';
import { EDialogComponent } from './edialog/edialog/edialog.component';
import { CurrencyPipe } from './pipes/currency.pipe';

@NgModule({
  declarations: [
    FormInputComponent,
    ButtonComponent,
    SelectComponent,
    ClickOutsideDirective,
    TooltipDirective,
    CustomToolTipDirective,
    CustomToolTipComponent,
    VsDatePipe,
    NoValuePipe,
    CurrencyPipe,
    EDialogComponent,
  ],

  imports: [FormsModule, ReactiveFormsModule, TranslateModule, CommonModule, PopoverModule],
  providers: [],
  exports: [
    FormInputComponent,
    ButtonComponent,
    SelectComponent,
    ClickOutsideDirective,
    TooltipDirective,
    TranslateModule,
    CommonModule,
    CustomToolTipDirective,
    PopoverModule,
    CustomToolTipComponent,
    VsDatePipe,
    NoValuePipe,
    CurrencyPipe,
    EDialogComponent,
  ],
})
export class SharedModule {}
